import React from 'react';
import styles from '@stylesheet';
import { Text, View } from 'react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const HelpScreen = () => {
  const theme = themeSelector();

  return (
    <View style={[styles.pageContainer, { backgroundColor: theme ? '#ffffff' : '#1a1a1a' }]}>
      <Text
        adjustsFontSizeToFit
        style={[
          styles.headerBanner,
          { color: theme ? '#1f2937' : '#f9fafb' }
        ]}
      >
        Help Screen
      </Text>
      <View style={[styles.noteContainer, { backgroundColor: theme ? '#f8fafc' : '#374151' }]}>
        <Text
          adjustsFontSizeToFit
          style={[
            styles.title,
            { color: theme ? '#1f2937' : '#f9fafb' }
          ]}
        >
          Help & Support
        </Text>
        {/* TODO: Implement help content */}
        <Text style={{ color: theme ? '#6b7280' : '#9ca3af', textAlign: 'center', marginTop: 20 }}>
          Help content and documentation will be available here.
        </Text>
      </View>
      <View
        style={[
          styles.separator,
          { backgroundColor: theme ? '#e5e7eb' : 'rgba(255,255,255,0.1)' }
        ]}
      />
    </View>
  );
};

export default HelpScreen;